import { useEffect, useState, useSyncExternalStore } from "react"
import { dynamicPositionStore } from "./dynamicPositionStore"
import { CircleMarker, Popup } from "react-leaflet"
import { Link } from "react-router-dom"
import { rangeID } from "./Mapa"
import { userStateStore } from "../zhr/users/usersStateStore"
import "./Mapa.css"


interface MarkerProp {
    id:string,
    color?: string,
    showLastSeenInfo: boolean
}

const parseMinutesToMs = (minutes: number): number => {
    return minutes * 60 * 1000;
}

const parseTime = (timeSpanInMs: number): string => {
    if (timeSpanInMs < parseMinutesToMs(3)) {
        return "chwilę temu"
    }
    else if (timeSpanInMs < parseMinutesToMs(5)) {
        return "<5 min temu"
    }
    else if (timeSpanInMs < parseMinutesToMs(10)) {
        return "<10 min temu"
    }
    else if (timeSpanInMs < parseMinutesToMs(30)) {
        return "<30 min temu"
    }
    else if (timeSpanInMs < parseMinutesToMs(60)) {
        return "<60 min temu"
    }
    else if (timeSpanInMs < parseMinutesToMs(3*60)) {
        return "<3 h temu"
    }
    else if (timeSpanInMs < parseMinutesToMs(6*60)) {
        return "<6 h temu"
    }
    else if (timeSpanInMs < parseMinutesToMs(24*60)) {
        return "<24 h temu"
    }
    else {
        return "ponad dobę temu"
    }
}

const afkColor = "gray"
const afkTime = parseMinutesToMs(4); //in milliseconds


function useForceUpdate(){
    const [value, setValue] = useState(0); // integer state
    return () => setValue(value => value + 1); // update state to force render
}

export function PlayerMarker(props:MarkerProp){

    const cord = useSyncExternalStore(
        dynamicPositionStore.subscribe.bind(null, props.id),
        dynamicPositionStore.getPlayerCord.bind(null, props.id))
    const user = userStateStore.getUser(props.id);
    const defaultColor = props.color ?? "#3388ff"
    const update = useForceUpdate()

    useEffect(()=>{
        if(cord){
            const timeToAfk = afkTime - (window.Date.now() - cord.timestamp)
            const timerId = setTimeout(update, timeToAfk)
            
            return ()=> {window.clearTimeout(timerId)}
        }
    }, [cord])


    if(cord === null){
        return (<></>)
    }
    
    const afk = window.Date.now() - cord.timestamp >= afkTime
    const color = afk ? afkColor : defaultColor

    return (
        <CircleMarker center={cord.coords} fillOpacity={0.9} pathOptions={{fillColor: color}} color="white" eventHandlers={{click: ()=> {dynamicPositionStore.bindTo(props.id, rangeID)}}}>
            <Popup>
                <Link to={`/users/${props.id}`}>{`${user?.name} ${user?.surname}`}</Link>
                {props.showLastSeenInfo && <div className="last-seen">{parseTime(window.Date.now() - cord.timestamp)}</div>}
            </Popup>
        </CircleMarker>
    )
}